// VideoPlayer.js
import React from 'react';
import styled from 'styled-components';
import { FaTimes } from 'react-icons/fa';

const VideoPlayerContainer = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${(props) => props.colors.formBackground};
  border-radius: 5px;
  position: relative;
`;

const SectionHeader = styled.div`
  font-size: 1rem;
  font-weight: bold;
  padding: 10px;
  border-radius: 5px 5px 0 0;
  color: white;
  background-color: ${(props) => props.colors.buttonBackground};
  text-align: center;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: transparent;
  border: none;
  font-size: 1.2rem;
  color: white;
  cursor: pointer;

  &:hover {
    color: #ccc;
  }
`;

const VideoContent = styled.div`
//   margin-top: 20px;
padding: 20px;
`;

const VideoPlayer = ({ videoLink, title, closeModal, colors }) => {
  // Helper function to render the appropriate video iframe based on the link
  console.log(videoLink,title)
  const renderVideo = () => {
    if (videoLink?.includes('youtube.com')) {
      const videoId = videoLink?.split('v=')[1];
      return (
        <iframe
          width="100%"
          height="315"
          src={`https://www.youtube.com/embed/${videoId}`}
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      );
    } else if (videoLink?.includes('vimeo.com')) {
      return (
        <iframe
          src={videoLink}
          width="100%"
          height="360"
          frameBorder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
          title="Vimeo video player"
        ></iframe>
      );
    }
    return null;
  };

  return (
    <>
    <SectionHeader colors={colors}>{title}</SectionHeader>
    <CloseButton onClick={closeModal} aria-label="Close">
      <FaTimes />
    </CloseButton>
    <VideoPlayerContainer colors={colors}>
      <VideoContent>{renderVideo()}</VideoContent>
    </VideoPlayerContainer>
    </>
  );
};

export default VideoPlayer;
